import { App } from '../App';
import { faker } from '@faker-js/faker/locale/sv';
import moment from 'moment';

export type PersonalIdOptions = {
  minAge?: number;
  maxAge?: number;
};

export const generatePersonalID = ({
  minAge,
  maxAge,
}: PersonalIdOptions = {}) => {
  const fakeBirthday = faker.date.birthdate({
    min: minAge || App.config.age.min + 1,
    max: maxAge || App.config.age.max - 1,
    mode: 'age',
  });
  const firstPart = moment(fakeBirthday).format('YYMMDD');
  const secondPart = faker.helpers.replaceSymbolWithNumber('###');
  const pNumber = `${firstPart}${secondPart}`;
  const pattern = '212121212';
  let checkSum = 0;
  pattern.split('').forEach((char, i) => {
    const check = parseInt(char, 10) * parseInt(pNumber.split('')[i], 10);
    checkSum += check
      .toString()
      .split('')
      .map((c) => parseInt(c, 10))
      .reduce((a, b) => a + b, 0);
  });
  const lastDigit = checkSum % 10 === 0 ? 0 : 10 - (checkSum % 10);
  return `${firstPart}-${secondPart}${lastDigit}`;
};

export const generatePhoneNumber = () => {
  const numberList = ['70', '71', '72', '73', '76', '79'];
  const firstNumber = faker.helpers.arrayElement(numberList);
  return faker.helpers.replaceSymbolWithNumber(`0${firstNumber}#######`);
};

export const generateEmail = (): string => {
  return faker.internet
    .email(undefined, undefined, undefined, {
      allowSpecialCharacters: false,
    })
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ''); // This removes accents, ñ => n, á => a, ě => e, ř => r, ů => u etc.
};

export const generatePassword = () => {
  return 'Password1';
};

export const generateBankAccountNumber = () => {
  return `${faker.helpers.replaceSymbolWithNumber('###########')}`;
};

export const generateFirstName = () => {
  return faker.name.firstName();
};

export const generateLastName = () => {
  return faker.name.lastName();
};

export const generateNumber = (min: number, max: number) => {
  return faker.finance.amount(min, max, 0);
};

export const generateProvince = () => {
  const esProvinces = [
    'Álava',
    'Albacete',
    'Alicante',
    'Almería',
    'Asturias',
    'Ávila',
    'Badajoz',
    'Baleares',
    'Barcelona',
    'Burgos',
    'Cáceres',
    'Cádiz',
    'Cantabria',
    'Castellón',
    'Ceuta',
    'Ciudad Real',
    'Córdoba',
    'Cuenca',
    'Girona',
    'Granada',
    'Guadalajara',
    'Guipúzcoa',
    'Huelva',
    'Huesca',
    'Jaén',
    'La Coruña',
    'La Rioja',
    'Las Palmas',
    'León',
    'Lleida',
    'Lugo',
    'Madrid',
    'Málaga',
    'Melilla',
    'Murcia',
    'Navarra',
    'Orense',
    'Palencia',
    'Pontevedra',
    'Salamanca',
    'Santa Cruz de Tenerife',
    'Segovia',
    'Sevilla',
    'Soria',
    'Tarragona',
    'Teruel',
    'Toledo',
    'Valencia',
    'Valladolid',
    'Vizcaya',
    'Zamora',
    'Zaragoza',
  ];

  return faker.helpers.arrayElement(esProvinces);
};

export const generateAddress = () => {
  return faker.address.streetAddress();
};

export const generatePostalCode = () => {
  return faker.helpers.regexpStyleStringParse(`[1-5][0-2][1-9][1-9][1-9]`);
};

export const generateCity = () => {
  return faker.address.cityName();
};

export const generateIncomeSource = () => {
  const sourceOfIncome = [
    'Housewife',
    'Student',
    'Working in non-profit organization',
    'Street merchants',
    'Employee in agriculture',
    'Permanent contract (public sector)',
    'Term contract (public sector)',
    'Permanent contract (private sector)',
    'Term contract (private sector)',
    'Pre retired',
    'Retired',
    'Pensioner',
    'Unemployed with provision',
    'Unemployed without benefits',
    'Self-employed',
    'Military, police, civil guard',
  ];

  return faker.helpers.arrayElement(sourceOfIncome);
};
